import React from 'react'
import { Container, FooterSection, Title, Text, ListDescription, ListItem } from './styles'

export const LegendCriteria = (): JSX.Element => {
  return (
    <Container>
      <FooterSection>
        <Title>Critérios usados para alarme de alteração em cada parâmetro</Title>

        <ListDescription>
          <ListItem>{`Circunferência abdominal: sexo masculino e ≥ 94 cm, ou sexo feminino e ≥ 80 cm`}</ListItem>
          <ListItem>{`Pressão arterial: sistólica ≥ 130 mmHg, ou diastólica ≥ 85 mmHg`}</ListItem>
          <ListItem>{`Triglicérides: ≥ 150 mg/dL`}</ListItem>
          <ListItem>{'Colesterol HDL: sexo masculino e < 40 mg/dL, ou sexo feminino e < 50 mg/dL'}</ListItem>
          <ListItem>{`Glicemia: ≥ 100 mg/dL`}</ListItem>
        </ListDescription>
      </FooterSection>

      <FooterSection>
        <Title>Critérios usados para alarme de síndrome metabólica</Title>
        <Text>{`A presença de pelo menos 3 dos seguintes critérios:`}</Text>

        <ListDescription>
          <ListItem>{`Circunferência abdominal: sexo masculino e ≥ 94 cm, ou sexo feminino e ≥ 80 cm`}</ListItem>
          <ListItem>{`Pressão arterial: sistólica ≥ 130 mmHg, ou diastólica ≥ 85 mmHg e/ou uso de anti-hipertensivo`}</ListItem>
          <ListItem>{`Triglicérides: ≥ 150 mg/dL HDL`}</ListItem>
          <ListItem>{`Colesterol HDL: sexo masculino e < 40 mg/dL, ou sexo feminino e < 50 mg/dL `}</ListItem>
          <ListItem>{'Glicemia: ≥ 100 mg/dL e/ou uso de antidiabético.'}</ListItem>
        </ListDescription>
      </FooterSection>

      <FooterSection>
        <Title>Interpretação das probabilidades </Title>
        <Text>
          A probabilidade mostrada é ajustada pelo limiar usado para obter a sensibilidade escolhida, e classificamos
          como "em risco" probabilidades acima de 50.
        </Text>
      </FooterSection>
    </Container>
  )
}
